import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
// firebase is SAS software as a service
import firebase from "./firebase";
import SimpleStorage from "react-simple-storage";

import Header from "./components/Header";
import Dishes from "./components/Dishes";
import Dish from "./components/Dish";
import DishForm from "./components/DishForm";
import NotFound from "./components/NotFound";
import Message from "./components/Message";
import Login from "./components/Login";
import Footer from "./components/Footer";

import "./assets/css/App.css";
import "./assets/css/font-style.css";


class App extends Component {
  state = {
    isAuthenticated: false,
    dishes: [],
    message: null
  };

  // for login
  onLogin = (email, password) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(user => {
        this.setState({ isAuthenticated: true });
      })
      .catch(error => console.error(error));
  };

  onLogout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.setState({ isAuthenticated: false });
      })
      .catch(error => console.error(error));
  };

  getNewSlugFromTitle = title => encodeURIComponent( 
    title
    .toLowerCase()
    .split(" ")
    .join("-")
  );

  // function to add new dish
  // modified to save posts to Firebase rather than state
  addNewDish = dish => {
    //give access to to main project database and within that, a subject of data under "dishes"
    //set up dishes ref in Firebase
    const dishesRef = firebase.database().ref("dishes");
    dish.slug = this.getNewSlugFromTitle(dish.title);
    //delete null dish key set up for new dish posts
    delete dish.key;
    //call .push(dish), push the dish post into the array of dishes
    dishesRef.push(dish);
    //to display a message when dish was saved
    this.displayMessage("saved");
  };

  // function to update dish
  // Firebase: dont need to update dishes in state since they will recieve changes automatically
  updateDish = dish => {
    //get specific post by adding the post key to post reference lookup
    const dishRef = firebase.database().ref("dishes/" + dish.key);
    dishRef.update({
      //take title and passes the title to arugument title in getNewSlugTitle to find title
      slug: this.getNewSlugFromTitle(dish.title),
      title: dish.title,
      content: dish.content,
      date: dish.date,
      //image: dish.image,
      imgUrl: dish.imgUrl
    });
    this.displayMessage("updated");
  };

  // take dish as parameter then checks a window.confirm modal to verify if user wants to delete dish
  // when you delete a post we will just be resaving with the link of the one that hasn't been deleted
  deleteDish = dish => {
    // 1. if user clicked ok in confirm window
    if (window.confirm("Delete this dish/recipe post?")) {
      // 2. find the post user wants to delete
      const dishRef = firebase.database().ref("dishes/" + dish.key);
      // call Firebase remove method to remove items based on key
      dishRef.remove();
      // because of live database sync dont need to remove post from state
      this.displayMessage("deleted");
    }
  };

  // setup live link between Firebase and this app
  componentDidMount() {
    const dishesRef = firebase.database().ref("dishes");
    // .on is a Firebase Method for real time sync with data
    // .on method gives a "Firebase snapshot" of data that contains updated reference to posts/dishes
    dishesRef.on("value", snapshot => {
      const dishes = snapshot.val();
      // create new empty dishes array
      const newStateDishes = [];
      // loop through dishes on Firebase and add them to new array
      // push all dishes on to each section
      for (let dish in dishes) {
        newStateDishes.push({
          //assigning dish from Firebase which is the key, to post.key in state
          key: dish,
          //then to access a specific post object use bracket object reference: dishes[dish]
          slug: dishes[dish].slug,
          title: dishes[dish].title,
          content: dishes[dish].content,
          date: dishes[dish].date,
          imgUrl: dishes[dish].imgUrl
        });
      }
      // add that new array to state
      this.setState({ dishes: newStateDishes });
    });
  }

  //method to show messages
  displayMessage = type => {
    this.setState({ message: type });
    setTimeout(() => {
      this.setState({message: null});
    }, 4800);
  }
 

  render() {
    return (
      <Router>
        <div className="App container-fluid">
        {
          // store data locally in local storage and not in state
          // this is the state object

          // if we have a token in our state that is authenticated set property and state to be authenticated and on logout call onLogout function
          // pass onLogout down to Header component
        }
        <SimpleStorage parent={this} />

          <Header isAuthenticated={this.state.isAuthenticated}
            onLogout={this.onLogout}
          />

 
          
          { // display messages and receive message type as props
            this.state.message && <Message type={this.state.message} />
          }
          <Switch>
          {
            // route here is homepage
            // pass in deleteDish function so that Dishes component can call that function
          }
            <Route
              exact
              path="/"
              render={() => (
                <Dishes 
                  isAuthenticated={this.state.isAuthenticated}
                  dishes={this.state.dishes}
                  deleteDish={this.deleteDish}
                />
              )}
            />

            {
            // Define path that will load Dish component
            // If path matches render will be called
            }
            <Route
              path="/dish/:dishSlug"
              render={props => {
                  // check to find dish that matches the one in the URL
                const dish = this.state.dishes.find(
                    // React Router auto provides a prop of match, which finds (a pattern) current slug from URL with props.match.params.dishSlug
                    // in each dish going to look for slug and going to match the params of dishSlug
                  dish => dish.slug === props.match.params.dishSlug
                );
                //if that returns a dish return specific dish
                if (dish) return <Dish dish={dish}/>;
                //otherwise return NotFound
                else return <NotFound />;
              }}
            />

            <Route
              exact
              path="/login"
              render={() =>
                !this.state.isAuthenticated ? (
                  <Login onLogin={this.onLogin} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />

            {
              // link to create new dish post
            }
            <Route
              exact
              path="/new"
              render={() => 
                // only load DishForm if user is authenticated
                // using keys instead of id for firebase, because IDs could be reused (when deleting and then adding) but keys are 1 time use
                this.state.isAuthenticated ? (
                <DishForm addNewDish={this.addNewDish} dish={{
                  key: null,
                  slug: "",
                  title: "",
                  content: "",
                  date: "",
                  image: "",
                  imgUrl: ""
                   }} 
                />
                ) : (
                <Redirect to="/login" />
                )
              }
            />

            {
              // 1. set path to "/edit:dishSlug", load when user clicks on a dish's edit link
              // 2. on Route render method (render={props => }) we want to get the slug from URL using props.match params.dishSlug which React Router provides
              // 3. check to see if dish exists (if(dish)). If dish exists load <DishForm />, if not redirect back to homepage to prevent errors
            }
            <Route path="/edit/:dishSlug" render={props => {
              const dish = this.state.dishes.find(dish => dish.slug === props.match.params.dishSlug);
                if (dish && this.state.isAuthenticated) {
                  return (
                    <DishForm updateDish={this.updateDish} dish={dish} />);
                } else if (dish && !this.state.isAuthenticated) {
                  return <Redirect to="/login" />;
                } else {
                  return <Redirect to="/" />;
                }
              }}
            />
            <Route component={NotFound} />
          </Switch>
          
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
